<template>
	<div ref="popupContainer">
		<!-- :style="'height: '+tableHeight+'px;'" -->
		<vs-popup
			:active.sync="showValidationPopup"
			title="Êtes-vous sûr de vouloir valider la supression du contract ?"
		>
			<div class="vx-row">
				<div class="vx-col sm:w-1/2">
					<vs-button color="primary" class="mt-2 w-full" @click="accept()"
						>Oui</vs-button
					>
				</div>
				<div class="vx-col sm:w-1/2">
					<vs-button color="primary" class="mt-2 w-full" @click="decline()"
						>Non</vs-button
					>
				</div>
			</div>
		</vs-popup>
		<!-- <vs-popup :active.sync="showNotepadPopup" title="Ajouter les Note">
      <NotepadPopup @close-popup = "clsoeNotePopUp()" :showPopup = "showNotepadPopup"/>
    </vs-popup> -->
		<vs-table
			stripe
			pagination
			max-items="25"
			:data="contracts"
			:key="refreshKey"
			:max-height="tableHeight + 'px'"
			id="tb"
			noDataText="Aucune contract corresponde"
		>
			<template slot="thead">
				<vs-th class="th-sticky">N°CONTRAT</vs-th>
				<vs-th class="th-sticky pdl0">Client</vs-th>
				<vs-th class="th-sticky pdl0">Date de création</vs-th>
				<vs-th class="th-sticky pdl0">Prestation</vs-th>
				<vs-th class="th-sticky pdl0">Type</vs-th>
				<!-- <vs-th>Fin prestation</vs-th> -->
				<vs-th class="th-sticky"
					><div class="w-full text-center" style="text-transform: uppercase">
						Commercial
					</div></vs-th
				>
				<vs-th class="th-sticky"
					><div class="w-full text-center" style="text-transform: uppercase">
						Consultant Lead
					</div></vs-th
				>
				<vs-th class="th-sticky"
					><div class="w-full text-center" style="text-transform: uppercase">
						Documents
					</div></vs-th
				>
				<vs-th class="th-sticky pdl0"
					><div class="w-full text-center" style="text-transform: uppercase">
						Statut
					</div></vs-th
				>
				<!-- <vs-th class="th-sticky"></vs-th> -->
				<vs-th class="th-sticky"></vs-th>
				<vs-th v-if="$acl.check('sadmin')" class="th-sticky"></vs-th>
			</template>

			<template slot-scope="{ data }">
				<vs-tr :key="index" v-for="(contract, index) in data">
					<!--For just calculating the number of rows-->
					<div v-show="false">
						{{ setRowNum(data.length) }}
					</div>
					<!--For just calculating the number of rows-->
					<vs-td :data="data[index].id">
						<span
							@click.stop="event.stopPropagation()"
							@click="displayContract(data[index])"
							class="hvr-underline hvr-underline-out"
							>{{ data[index].id }}
						</span>
					</vs-td>
					<vs-td :data="data[index].society_name"
						><span
							class="hvr-underline"
							@click="displaySocietyPopup(data[index].society_id)"
							><strong>{{ data[index].society_name }}</strong></span
						></vs-td
					>
					<vs-td :data="data[index].start_date">{{
						getDateToFrenchFormat(data[index].true_creation_date)
					}}</vs-td>
					<vs-td :data="data[index].delivery_name">{{
						data[index].delivery_name
					}}</vs-td>
					<vs-td :data="data[index].type_name">{{
						data[index].type_name
					}}</vs-td>
					<!-- <vs-td :data="data[index].end_date">{{ getDateToFrenchFormat(data[index].end_date) }}</vs-td> -->
					<vs-td
						:data="data[index].commercial_name"
						v-if="data[index].commercial_name"
						class="pdl0"
					>
						<avatar-message-chip
							:key="index"
							:user="{
								users_id: data[index].commercial_id,
								name: data[index].commercial_name,
							}"
							:contract="data[index]"
						/>
					</vs-td>
					<vs-td v-else> </vs-td>
					<vs-td
						:data="data[index].account_manager_avatars"
						v-if="data[index].account_manager_avatars.length > 0"
						class="pdl0"
						:key="refreshLead"
					>
						<avatar-message-chip
							:key="index"
							:user="data[index].account_manager_avatars[0]"
							:contract="data[index]"
						/>
					</vs-td>
					<vs-td v-else> </vs-td>

					<vs-td
						v-if="
							allDocuments.filter((doc) => doc.contract_id == data[index].id)
								.length > 0
						"
						class="pdl0"
						style="text-align: -webkit-center"
					>
						<vs-button
							color="primary"
							size="large"
							type="flat"
							icon-pack="feather"
							icon="icon-file"
							@click="$emit('display-documents', data[index].id)"
						></vs-button>
					</vs-td>
					<vs-td v-else> </vs-td>

					<vs-td :data="data[index].status" class="pdl0">
						<div class="flex center">
							<vs-chip
								style="width: 80px; margin-right: 0"
								:color="getContractStatusColor(data[index].status)"
								>{{ getContractStatus(data[index].status) }}</vs-chip
							>
						</div>
					</vs-td>
					<!-- <vs-td style="text-align: center">
						<vx-tooltip
							text="Action Commerciale"
							position="top"
							style="text-align: -webkit-center; margin-right: 0 !important"
						>
							<vs-button
								size="large"
								color="primary"
								type="flat"
								icon-pack="feather"
								icon="icon-message-square"
								@click="displayNotePadPopup(data[index])"
							></vs-button>
						</vx-tooltip>
					</vs-td> -->
					<vs-td style="text-align: center">
						<vx-tooltip
							text="Afficher"
							position="top"
							style="text-align: -webkit-center; margin-right: 0 !important"
						>
							<vs-button
								size="large"
								color="primary"
								type="flat"
								icon-pack="feather"
								icon="icon-eye"
								@click="displayContract(data[index])"
							></vs-button>
						</vx-tooltip>
					</vs-td>
					<vs-td v-if="$acl.check('sadmin')" style="text-align: center">
						<vx-tooltip
							text="Effacer"
							position="top"
							style="text-align: -webkit-center; margin-right: 0 !important"
						>
							<vs-button
								size="large"
								color="danger"
								type="flat"
								icon-pack="feather"
								icon="icon-trash-2"
								@click="displayValidationPopup(data[index])"
							></vs-button>
						</vx-tooltip>
					</vs-td>
				</vs-tr>
			</template>
		</vs-table>
	</div>
</template>

<script>
import Vue from "vue";
import store from "@/store/store";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin.js";
import Contract from "@/entities/Contract";
import SocietyInfoPopup from "@/components/popups/SocietyInfoPopup";
import NotepadPopup from "@/components/popups/NotepadPopup.vue";
import AvatarMessageChip from "../chips/AvatarMessageChip.vue";
// import XLSX from "xlsx";

export default {
	name: "ContractsTable",
	props: {
		contracts: Array,
		refreshKey: Number,
		refreshLead: {
			type: Number,
			default: 0,
		},
	},
	components: { NotepadPopup, AvatarMessageChip },
	mixins: [dbFieldConvertor, utilsMixin],
	computed: {
		filterCardHeight: () => {
			return store.state.filterCardHeight;
		},
		isFilterDown: () => {
			return store.state.isFilterDown;
		},
		horizentalNavBarHeight: () => {
			return store.state.horizentalNavBarHeight;
		},
		windowHeigth: () => {
			return store.state.windowHeigth;
		},
		tableHeight: () => {
			return store.state.tableHeight;
		},
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
		societies: () => {
			return store.state.societies;
		},
	},
	data() {
		return {
			tabHeight: 0,
			rowNum: 0,
			apiUrl: this.$store.state.backendApiUrl,
			apiErrorMsg: null, // catching api error message
			selectedSociety: null,
			showSocietyPopup: false,
			showLeadMessageIcon: false,
			showLeadMessageIconIndex: null,
			showConsultantMessageIconIndex: null,
			refreshLead: 0,
			showConsultantMessageIcon: false,
			showValidationPopup: false,
			showNotepadPopup: false,
			contractToDelete: null,
			showModal: false,
			allDocuments: [],
		};
	},
	updated() {
		store.dispatch(
			"updateTableHeight",
			this.windowHeigth -
				this.horizentalNavBarHeight -
				document.getElementById("fliterCard").clientHeight -
				0.21 * this.windowHeigth
		);
	},
	mounted() {
		store.dispatch(
			"updateFilterCardHeight",
			document.getElementById("fliterCard").clientHeight
		);
		store.dispatch(
			"updateTableHeight",
			this.windowHeigth -
				this.horizentalNavBarHeight -
				document.getElementById("fliterCard").clientHeight -
				0.21 * this.windowHeigth
		);
		this.$nextTick(() => {
			window.addEventListener("resize", () => {
				store.dispatch(
					"updateTableHeight",
					this.windowHeigth -
						this.horizentalNavBarHeight -
						this.filterCardHeight -
						0.21 * this.windowHeigth
				);
			});
		});
	},
	beforeUnmount() {
		// Find and remove any lingering tooltip elements
		const tooltips = document.querySelectorAll(".vx-tooltip-content");
		tooltips.forEach((tooltip) => tooltip.remove());
	},
	created() {
		this.getAllProducts();
		this.getAllProviders();
		this.getAllServices();
		this.getAllDocuments();
		this.sortAvatars();
	},

	watch: {
		isFilterDown: function () {
			store.dispatch(
				"updateFilterCardHeight",
				document.getElementById("fliterCard").clientHeight
			);
			store.dispatch(
				"updateTableHeight",
				this.windowHeigth -
					this.horizentalNavBarHeight -
					this.filterCardHeight -
					0.25 * this.windowHeigth
			);
		},

		contracts: function (data) {
			if (data.length == 0) {
				this.setRowNum(0);
			}
			this.sortAvatars();
		},
	},
	methods: {
		/** Toggle Lead Message Icon */
		onLeadIconHover(index, isShow) {
			this.showLeadMessageIcon = isShow;
			this.showLeadMessageIconIndex = index;
			// this.refreshLead++
		},
		/** Toggle Consultant Message Icon */
		onConsultantIconHover(index, isShow) {
			this.showConsultantMessageIcon = isShow;
			this.showConsultantMessageIconIndex = index;
			// this.refreshLead++
		},
		clsoeNotePopUp() {
			this.showNotepadPopup = false;
		},
		setRowNum(len) {
			store.dispatch("setRowNum", len);
		},
		getAllDocuments() {
			this.$http
				.get(this.apiUrl + "contracts_documents/list/all")
				.then((result) => {
					this.allDocuments = result.data;
				});
		},
		getAllProducts() {
			this.$store.dispatch("getAllProducts");
		},
		getAllServices() {
			this.$store.dispatch("getAllServices");
		},
		getAllProviders() {
			this.$store.dispatch("getAllProviders");
		},

		/**
		 * Add prefix to url using the mixin
		 */
		getPrefixedUrl(url) {
			let prefixedUrl = this.urlPrefixAdder(url);
			return prefixedUrl;
		},

		deleteContract(contract) {
			let contractToDelete = new Contract(contract);
			contractToDelete.delete((err, res) => {
				if (err)
					if (res) {
						//console.log(err);
						this.$store.dispatch("getAllContractsWithContractsUsers");
						this.$emit("delete-line", contract);
					}
			});
		},

		updateContract(contractId) {
			this.$emit("modify-contract", contractId);
		},

		displayContract(contract) {
			contract["edit"] = false;
			this.$emit("display-contract", contract);
		},

		getAccountManagerIsLead(contract, UserId) {
			//console.log("getAccountManagerIsLead");
			let newContract = new Contract(contract);
			return newContract.getAccountManagerIsLead(contract.id, UserId);
		},

		getCollaboratorAvatar(userId) {
			let foundAvatar = this.allCollaboratorsAvatar.find(
				(avatar) => avatar.id == userId
			);
			if (foundAvatar) return foundAvatar.avatar;
			else return null;
		},

		/**
		 * Fetch society by id
		 * @param {Number} societyId - The society id
		 */
		getSocietyById(societyId) {
			return this.societies.find((society) => society.id == societyId);
		},

		/**
		 * Fetch image if society.image is true else return false
		 * @param {Society} society - The society from which image is requested
		 */
		getSocietyImage(societyId) {
			this.$http
				.get(this.apiUrl + "society/getImg/" + societyId)
				.then((image) => {
					if (image.data.length > 0) {
						return {
							id: societyId,
							image: image.data,
						};
					} else {
						return null;
					}
				})
				.catch((err) => {
					//console.log(err);
				});
		},

		async displaySocietyPopup(societyId) {
			//Initialisation des données pour le popup
			this.selectedSociety = null; // Always reset data before assigning it
			this.selectedSociety = JSON.parse(
				JSON.stringify(this.getSocietyById(societyId))
			);
			const image = await this.$http.get(
				this.apiUrl + "society/getImg/" + societyId
			);

			let imgObject = null;
			if (image.data.length > 0) {
				imgObject = image.data;
			}

			this.selectedSociety.image = imgObject;
			this.showSocietyPopup = true;

			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(SocietyInfoPopup);
			let societyPopup = new ComponentClass({
				propsData: {
					society: this.selectedSociety,
					popupActive: this.showSocietyPopup,
					router: this.$router,
					apiUrl: this.apiUrl,
				},
			});
			societyPopup.$mount();
			this.$refs.popupContainer.appendChild(societyPopup.$el);
		},
		displayNotePadPopup(contract, destinationUserId) {
			//Initialisation des données pour le popup
			this.showNotepadPopup = true;
			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(NotepadPopup);
			let notepadPopup = new ComponentClass({
				propsData: {
					contract_id: contract.id,
					popupActive: this.showNotepadPopup,
					router: this.$router,
					apiUrl: this.apiUrl,
					society_id: contract.society_id,
					destinationUserId: Number(destinationUserId) || destinationUserId,
				},
			});
			notepadPopup.$mount();
			this.$refs.popupContainer.appendChild(notepadPopup.$el);
			notepadPopup.$on("close-popup", (data) => {
				this.showNotepadPopup = false;
			});
		},

		displayValidationPopup(contract) {
			this.contractToDelete = contract;
			this.showValidationPopup = true;
		},

		accept() {
			this.deleteContract(this.contractToDelete);
			this.showValidationPopup = false;
		},

		decline() {
			this.contractToDelete = null;
			this.showValidationPopup = false;
		},
		sortAvatars() {
			for (let n = 0; n < this.contracts.length; n++) {
				for (
					let i = 0;
					i < this.contracts[n].account_manager_avatars.length;
					i++
				) {
					if (this.contracts[n].account_manager_avatars[i].is_lead == 1) {
						let tmp = this.contracts[n].account_manager_avatars[i];
						this.contracts[n].account_manager_avatars[i] =
							this.contracts[n].account_manager_avatars[0];
						this.contracts[n].account_manager_avatars[0] = tmp;
					}
				}
			}
		},

		downloadBccgv(contractId, refIndex) {
			let target_url = this.apiUrl + "contract/getBccgv/" + contractId;
			this.$http
				.get(target_url, { responseType: "blob" })
				.then((fetched_bccgv) => {
					let fileURL = window.URL.createObjectURL(
						new Blob([fetched_bccgv.data])
					);
					let fileLink = document.createElement("a");
					// //console.log("fetched_bcacgv", fetched_bccgv)
					fileLink.href = fileURL;
					fileLink.setAttribute("download", "contract-" + contractId + ".pdf");
					document.body.appendChild(fileLink);
					fileLink.click();
				})
				.catch((err) => {
					//console.log(err);
				});
			this.$refs["bccgvButton" + refIndex][0].blurButton();
			setTimeout("alert('Téléchargement en cours...')", 800);
		},
	},
};
</script>

<style>
.center {
	justify-content: center;
}

.th-sticky {
	position: sticky;
	top: 0;
	background-color: inherit;
}

.vs-con-tbody.vs-table--tbody {
	height: 100%;
	/* max-height: 60vh; */
}
.hvr-underline:hover {
	color: aqua;
	text-decoration: underline;
	cursor: pointer;
}
.vs-tooltip.vs-tooltip-top.vs-tooltip-null {
	word-break: break-all;
}
.vs-pagination--buttons.btn-next-pagination.vs-pagination--button-next > i,
.vs-pagination--buttons.btn-prev-pagination.vs-pagination--button-prev.disabled
	> i {
	align-self: center;
}

.con-vs-avatar {
	border-color: rgb(8, 176, 185) !important;
}
</style>
